'use strict';

var React = require('react');
var assetsHelper = require('../../helper/assetsHelper');

/**
 * 时间选择器
 */
var TimePicker = React.createClass({
  render: function () {
    return (<img className="component-SimpleCom"
                 src={assetsHelper.getComponentAsset('TimePicker')}
    />);
  }
});

module.exports = TimePicker;



// WEBPACK FOOTER //
// ./src/views/Components/TimePicker.jsx